import * as React from 'react';

export const InfoIcon = () => <i className='fa fa-info-circle' />;
export const SuccessIcon = () => <i className='fa fa-check-circle status-icon--success' />;
export const WarningIcon = () => <i className='fa fa-exclamation-triangle status-icon--pending' />;
export const ErrorIcon = () => <i className='fa fa-exclamation-circle status-icon--error' />;
